import React from 'react';
import PropTypes from 'prop-types';
import Mousetrap from 'mousetrap';
import $ from '../../../../offline/jquery.min.js';

const iconClearSelect =  'M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z';

class MouseAndKeyboardCloseHandler extends React.PureComponent {
  componentDidMount() {
    Mousetrap.bind('esc', this.props.onClickOutside);
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    Mousetrap.unbind('esc');
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (!this.props.getDomElement().contains(event.target)) {
      if (($(event.target).find('path[d="' + iconClearSelect + '"]').length === 0) && !$(event.target).is('path[d="' + iconClearSelect + '"]')) {
        this.props.onClickOutside(event.target);
      }
    }
  };

  render() {
    return (
      <>
        { this.props.children }
      </>
    );
  }
}

MouseAndKeyboardCloseHandler.propTypes = {
  getDomElement: PropTypes.func.isRequired,
  onClickOutside: PropTypes.func.isRequired,
};

export default MouseAndKeyboardCloseHandler;